import { tns } from 'tiny-slider/src/tiny-slider';

class BlockSlider {
	constructor(el) {
		this.el = el;

        const sliderContainer = this.el.querySelector('.block-slider__slider');
        const navContainer = this.el.querySelector('.block-slider__nav-container');
        const slideCount = sliderContainer ? sliderContainer.children.length : 0;

        if (!sliderContainer || !slideCount) {
            return;
        }

        const itemsTablet = Math.max(1, Math.min(2, slideCount));
        const itemsDesktop = Math.max(1, Math.min(4, slideCount));

        const blockSlider = tns({
            container: sliderContainer,
            controls: false,
            autoHeight: true,
            axis: 'horizontal',
            swipeAngle: false,
            speed: 400,
            rewind: true,
            navContainer: navContainer,
            mouseDrag: true,
            slideBy: 'page',
            items: 1,
            edgePadding: 65,
            responsive: {
                768: {
                    items: itemsTablet,
                    edgePadding: 0
                },
                1024: {
                    items: itemsDesktop,
                    edgePadding: 0
                }
            }
        });
    }
}

export default BlockSlider;
